import _ from 'lodash';

export default function cashConverter(num) {
    if (!num || _.isNaN(+num)) return 0;

    const formattedString = Intl.NumberFormat('en-US');
    return formattedString.format(+num);
}
